module.exports = __webpack_public_path__ + "media/images/footer_page/about/about-2-f8be086a2fdae89dfea903c5a7286056.png";